var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningRedTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C50020",
  d: "M8 4.143c-.403 0-.73.356-.73.796v5.573c0 .44.327.797.73.797.404 0 .73-.357.73-.797V4.94c0-.44-.326-.796-.73-.796M8 11.892c-.482 0-.873.427-.873.953s.39.953.874.953c.482 0 .874-.427.874-.953s-.392-.953-.874-.953"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C50020",
  fillRule: "evenodd",
  d: "M6.996.645c.437-.86 1.571-.86 2.008 0l6.85 13.498c.424.834-.129 1.857-1.003 1.857H1.149C.275 16-.278 14.977.145 14.143zM1.344 14.624 8 1.51l6.656 13.114z",
  clipRule: "evenodd"
})));
export { SvgWarningRedTriangle as ReactComponent };